/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Something_Went_WrongInputs */

const en_common_something_went_wrong = /** @type {(inputs: Common_Something_Went_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong.`)
};

const fr_common_something_went_wrong = /** @type {(inputs: Common_Something_Went_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite.`)
};

/**
* | output |
* | --- |
* | "Something went wrong." |
*
* @param {Common_Something_Went_WrongInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const common_something_went_wrong = /** @type {((inputs?: Common_Something_Went_WrongInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Something_Went_WrongInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_common_something_went_wrong(inputs)
	return en_common_something_went_wrong(inputs)
});